import * as React from 'react';
import { ReactComponent as ShareIconSVG } from '../../assets/icons/mevo/ic_share.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ShareIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ShareIconSVG} variantPlaces={1} {...props} />;
};

export default ShareIcon;
